var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33339 11.3684C5.66067 11.7173 6.1913 11.7173 6.51858 11.3684L15.4074 1.89476C15.7347 1.54595 15.7347 0.980413 15.4074 0.631602C15.0802 0.282792 14.5495 0.282793 14.2223 0.631604L6.5186 8.8421C6.19132 9.19091 5.6607 9.19091 5.33342 8.8421L1.77781 5.05257C1.45053 4.70375 0.919908 4.70376 0.592628 5.05257C0.26535 5.40138 0.265347 5.96691 0.592624 6.31572L5.33339 11.3684Z",
    fill: "#00a000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a4dc2e206b3983644373a6cdb04f40e4.svg";
export { ForwardRef as ReactComponent };